//////// GHG 2.3 EA
const twoThreeSchema = {
  title: "2.3 Indirect Emissions from Purchased/Acquired Heating",
  addAPI: "cat2_2AddEmissionActivityAPI",
  cat: "cat2_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Energy Supplier or Region",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Energy Type",
      optionsAPI: "ghg2_3ActivityDropdown",
      required: true,
    },
  ],
};

export default twoThreeSchema;
